import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from '../hooks/useInView';
export function MecanismoNuevoSection() {
  const [ref, isInView] = useInView({
    threshold: 0.2
  });
  return <section id="mecanismo" className="py-16 sm:py-32 relative overflow-hidden bg-[#050505] border-t border-white/5 scroll-mt-[56px] sm:scroll-mt-[70px]" data-id="element-323">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 text-center relative z-10" data-id="element-324">
        <motion.div ref={ref} initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 30
      }} transition={{
        duration: 0.8
      }} data-id="element-325">
          <h2 className="font-serif text-3xl sm:text-4xl md:text-5xl font-black text-white mb-12 leading-tight" data-id="element-326">
            Por qué este <span className="text-gold" data-id="element-327">sistema funciona</span>
          </h2>

          <div className="bg-[#0c0c0e] border border-white/10 p-8 sm:p-12 rounded-3xl shadow-2xl relative overflow-hidden" data-id="element-328">
            <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-1 bg-gradient-to-r from-transparent via-gold to-transparent opacity-50" data-id="element-329" />

            <div className="space-y-6 text-lg sm:text-xl text-white/80 font-medium leading-relaxed" data-id="element-330">
              <p data-id="element-331">Tu mente filtra la realidad según lo que cree posible.</p>
              <p data-id="element-332">
                Cuando operas desde tensión, duda o repetición, puedes dejar de
                ver opciones que ya están frente a ti.
              </p>
              <p className="text-gold font-bold text-xl sm:text-2xl py-4" data-id="element-333">
                El Código 888 te ayuda a ordenar ese filtro interno para que
                empieces a percibir, decidir y actuar con más claridad.
              </p>
              <p className="text-white font-bold" data-id="element-334">
                Y ahí es donde comienza el cambio.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}